import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" }); }, [pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground antialiased">
      <Header />
      <main data-testid="site-main" className="pt-16 md:pt-20">{children}</main>
      <Footer />
    </div>
  );
}
